import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TenantContextService {
  readonly slug = signal<string | null>(localStorage.getItem('esms.tenant_slug'));

  set(slug: string) {
    localStorage.setItem('esms.tenant_slug', slug);
    this.slug.set(slug);
  }

  clear() {
    localStorage.removeItem('esms.tenant_slug');
    this.slug.set(null);
  }
}
